import request from '@/api/request'

export function listIncompleteRescue(){
  return request({
    url: 'webapi/rescue/list',
    method: 'get'
  })
}

export function launchRescue(data){
  const req = {
    rescueId: data
  }
  return request({
    url: 'webapi/rescue/launchRescue',
    method: 'post',
    data: req
  })
}
